import { render, staticRenderFns } from "./newEstateForm.vue?vue&type=template&id=60ead855&scoped=true&"
import script from "./newEstateForm.vue?vue&type=script&lang=js&"
export * from "./newEstateForm.vue?vue&type=script&lang=js&"
import style0 from "./newEstateForm.vue?vue&type=style&index=0&id=60ead855&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ead855",
  null
  
)

export default component.exports